<template>
    <div class="context">
        <component :is="componentId"
                   @changeTopTab="switchModule"
                   :ref="componentId"></component>
    </div>
</template>

<script>
    import tableView from "./table"
    import addView from "./add"
    import commonIll from "./commonIll"

    export default {
        name: "",
        components: {
            tableView,
            addView,
            commonIll
        },
        data() {
            return {
                componentId: 'tableView'
            }
        },
        methods: {
            switchModule(id) {
                this.componentId = id
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }
</style>